"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonRequestParamsPacker = void 0;
var util_1 = require("../../util");
var CommonRequestParamsPacker = /** @class */ (function () {
    function CommonRequestParamsPacker() {
    }
    /**
     * 通用请求通道参数打包
     * @param message
     * @param options
     */
    CommonRequestParamsPacker.prototype.pack = function (message, options) {
        var _a;
        var content = {
            common: {
                type: message.data.type,
                docid: options.serverVars.globalPadId,
                uid: options.uid,
                // 历史字段，先这么用吧
                session_type: 0,
                uuId: options.uuId,
                padType: (_a = options.module) !== null && _a !== void 0 ? _a : '',
                padSubType: message.data.padSubType,
            },
            respective: message.data.changeset,
        };
        var padId = options.serverVars.globalPadId;
        var xsrf = util_1.Cookie.getXsrf();
        var body = util_1.JsonUtil.jsonStringify({
            padId: padId,
            xsrf: xsrf,
            data: util_1.JsonUtil.jsonStringify(content),
        });
        return body;
    };
    return CommonRequestParamsPacker;
}());
exports.CommonRequestParamsPacker = CommonRequestParamsPacker;
